import React from 'react'

type SvgIconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>

export function lazyWithPreload<T extends SvgIconComponent>(
  factory: () => Promise<{ default: T }>
) {
  const Component = React.lazy(factory)

  return {
    Component,
    preload: factory,
  }
}
